import React from 'react';
import styles from './ErrorFallback.module.css';
import errorNeon from '../../assets/images/error-neon.png';

interface ErrorFallbackProps {
  error?: Error;
  resetErrorBoundary?: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.illustrationWrapper}>
          <img 
            src={errorNeon} 
            alt="Gold Neon M Logo Error"
            className={styles.illustration}
          />
        </div>
        
        <h1 className={styles.headline}>Pauză de publicitate pentru valoarea ta</h1>
        
        <p className={styles.message}>
          Sistemul a luat o pauză de dedicații neprevăzută. 
          Revenim imediat pe scenă cu mai multă energie!
          {error && (
            <code style={{ display: 'block', marginTop: '1rem', color: 'var(--text-disabled)', fontSize: '0.75rem' }}>
              Error ID: {error.message}
            </code>
          )}
        </p>
        
        <div className={styles.actions}>
          <button className={styles.primaryButton} onClick={resetErrorBoundary || (() => window.location.reload())}>
            Relansează show-ul
          </button>
          <button className={styles.secondaryButton} onClick={handleGoHome}>
            Mergi la masă
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
